module.exports = __webpack_public_path__ + "static/img/manual-16.30aa396.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-16.png
// module id = IaYl
// module chunks = 4